module.exports = __webpack_public_path__ + "f3caaa8ffaed6a3596476db0723be3f3.jpg";